module.exports = __webpack_public_path__ + "img/eve-no-img.9a928b7f.jpg";